import { House, Newspaper, Search, User } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import NavMenuItem from '@/components/nav/NavMenuItem.tsx';

const NavMenu: FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="absolute bottom-0 left-0 flex w-screen justify-between bg-neutral-700 px-6 text-neutral-300">
            <NavMenuItem icon={House} label={t('nav.home')} onClick={() => navigate('/')} />
            <NavMenuItem icon={Newspaper} label={t('nav.feed')} onClick={() => navigate('/feed')} />
            <NavMenuItem icon={Search} label={t('nav.search')} onClick={() => navigate('/search')} />
            <NavMenuItem icon={User} label={t('nav.profile')} onClick={() => navigate('/profile')} />
        </div>
    );
};

export default NavMenu;
